import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const alert = {
    success,
    error,
    clear,
};

function success(message) {
    //console.log(message);
    toast(message, { containerId: 'TOP_RIGHT', autoClose: 5000, type: toast.TYPE.SUCCESS });
}

function error(message) {
    //console.log(message);
    toast(message, { containerId: 'TOP_RIGHT', autoClose: 5000, type: toast.TYPE.ERROR });
}

function clear() {
    // toast.dismiss();
}